import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import type { TextFieldProps } from '@mui/material/TextField';

import { type AllRepeatDetails, OnThe } from '../../Repeat.types';
import { getLabelSize, onTheTextMapping } from '../../utils';

interface SelectPositionProps {
  value: AllRepeatDetails;
  onChange: (value: AllRepeatDetails) => void;
  disabled: boolean;
  inputSize: 'small' | 'medium';
  inputVariant: TextFieldProps['variant'];
}
const sxMinWidth = { minWidth: 150 };

// TODO should there be a max number of positions? Change to AutoComplete from Select?
const SelectPosition = ({ value, onChange, disabled, inputSize, inputVariant }: SelectPositionProps) => {
  const labelSize = getLabelSize(inputSize);
  return (
    <FormControl fullWidth>
      <InputLabel id="select-pos-label" disabled={disabled} size={labelSize}>
        Select Position
      </InputLabel>
      <Select
        sx={sxMinWidth}
        {...{ disabled: disabled, size: inputSize }}
        onChange={(e) => {
          const currentVal = e.target.value as number[];
          onChange({ ...value, bySetPos: currentVal });
        }}
        value={value.bySetPos}
        multiple
        labelId="select-pos-label"
        label="Select Position"
        variant={inputVariant}
      >
        {Object.keys(OnThe).map((key) => (
          <MenuItem key={key} value={Number.parseInt(OnThe[key as keyof typeof OnThe], 10)}>
            {onTheTextMapping[OnThe[key as keyof typeof OnThe]]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectPosition;
